class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);

    if($("#cart-notification-product .gift_variant")[0]){
      var gift_id = $(this).find('.gift_variant').attr('data-gift-variant') != undefined ? $(this).find('.gift_variant').attr('data-gift-variant'): 0;
      var max_spend = $(this).find('.max_spend').attr('data-max-spend') != undefined ? $(this).find('.max_spend').attr('data-max-spend') : 0;
      var price = $(this).find('.product_price').attr('data-price') != undefined ? $(this).find('.product_price').attr('data-price')/100 : 0;
      var cart_total = $(this).find('.cart_total').attr('data-cart-total') != undefined ? $(this).find('.cart_total').attr('data-cart-total')/100 : 0;
      cart_total = cart_total + price;

      if(max_spend != undefined || max_spend > 0 ){
        if(cart_total > max_spend){
          this.cartCheck(gift_id);
        }
      }else{
        this.cartCheck(gift_id);
      }
    }

  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  cartCheck(gift_id){
    var in_cart = false;

    $.ajax({
      type: "post",
      url: "/cart.js",
      dataType: "json",	
      async: true, 
      success: function(data) {

        $.each(data.items, function( index, item ) {
          if(item.id == gift_id){
            in_cart = true;
          }
        });
        if(in_cart == false){
          $.ajax({
            type: "post",
            url: "/cart/add.js",
            data: "quantity=1&id=" + gift_id,
            dataType: "json",	
            async: true, 
            success: function() {
              console.log('success')
            },
            error: function(i) {
              console.log('error')
            }
          })
        }
      },
      error: function(i) {
        console.log('error')
      }
    })
  }
  
}

customElements.define('cart-notification', CartNotification);
